import controller from './new.controller';
import template from './new.pug';

const NewComponent = {
  template,
  controller,
};

export default NewComponent;



// WEBPACK FOOTER //
// ./client/app/cases/new/new.component.js